export default function Marquee() {
  const text = "Esplora senza confini";
  const items = Array.from({ length: 8 });
  return (
    <div className="bg-secondary text-secondary-foreground py-8 md:py-12 overflow-hidden border-y border-foreground/10" data-testid="marquee">
      <div className="flex whitespace-nowrap animate-marquee">
        {[0, 1].map((group) => (
          <div key={group} className="flex items-center shrink-0">
            {items.map((_, i) => (
              <span key={i} className="flex items-center">
                <span className="font-serif-editorial italic text-4xl md:text-6xl px-10">{text}</span>
                <span className="text-primary text-2xl md:text-4xl">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
